
import { mixins, Options } from 'vue-class-component';
import LoadingScreen from '@/components/LoadingScreen.vue';
import CartWidgetMixin from '@/mixins/cartWidget';
import { CountdownType } from '@/store';

@Options({
  components: {
    LoadingScreen
  }
  // data() {
  //   return {
  //     starFavorite: require('@/assets/images/star-favorite.svg')
  //   };
  // }
})
export default class MDiscountInactive extends mixins(CartWidgetMixin) {
  get starFavorite() {
    if (this.customStarImage) {
      return this.customStarImage;
    } else {
      return require('@/assets/images/star-favorite.svg');
    }
  }

  get countdownLoaded() {
    return !!this.getters.countdown && Object.keys(this.getters.countdown).length > 0;
  }
  get expired() {
    return this.getters.countdownType === CountdownType.EXPIRED;
  }
  get activeCountdown() {
    return [CountdownType.TO_START, CountdownType.TO_END].includes(this.getters.countdownType);
  }
  get activeCountdownText() {
    let retval;
    const countdownType = this.getters.countdownType;

    if (countdownType === CountdownType.TO_START) {
      retval = 'NFT Discount Starts In';
    } else if (countdownType === CountdownType.TO_END) {
      retval = 'NFT Discount Ends In';
    } else {
      retval = '';
    }

    return retval;
  }
}
